import { TextButton } from "../../index";

const GeneralSubmitButton = ({ text, className }) => {
    return (
        <TextButton className={className} type="submit">
            {text}
        </TextButton>
    );
};

export default GeneralSubmitButton;
